import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieConsentBanner from "@/components/CookieConsentBanner";
import FloatingFeedbackButton from "@/components/FloatingFeedbackButton";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg focus:text-sm focus:font-medium"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className="flex-1">{children}</main>
      <Footer />
      <CookieConsentBanner />
      <FloatingFeedbackButton />
    </div>
  );
};

export default Layout;
